import { Cards, Header, SpaceBetween } from "@amzn/awsui-components-react-v3";
import React from "react";
import { createCardDefinition } from "./cards-config";
import { NavigableApplicationsObject } from "./types";
import USER_DISPLAY_STRINGS from "../../resources/user_display_strings";

interface RecentAppsPaneProps {
    recentlyUsedLinks: NavigableApplicationsObject[];
    onTogglePinApp?: (app: NavigableApplicationsObject) => void;
    loading?: boolean;
    error?: Error | null;
}

export default function RecentAppsPane({ recentlyUsedLinks, onTogglePinApp, loading = false, error }: RecentAppsPaneProps) {

    const pinnedApps = recentlyUsedLinks ? recentlyUsedLinks.filter(app => app.isPinned) : [];
    const nonPinnedApps = recentlyUsedLinks ? recentlyUsedLinks.filter(app => !app.isPinned) : [];
    
    const sortedPinnedApps = [...pinnedApps].sort((a, b) => a.navTitle.localeCompare(b.navTitle));
    
    const displayLinks = [...sortedPinnedApps, ...nonPinnedApps];

    return (
        <SpaceBetween size="m">
            <Cards 
                cardDefinition={createCardDefinition({ onTogglePinApp })}
                cardsPerRow={[ { cards:1 },{ minWidth:500,cards:2 } ]}
                items={displayLinks}
                trackBy="navLink"
                loading={loading}
                loadingText={USER_DISPLAY_STRINGS.recentAppsLoadingText}
                empty={
                    <div>
                        <h3>{USER_DISPLAY_STRINGS.recentAppsEmptyHeader}</h3>
                        <p>{USER_DISPLAY_STRINGS.recentAppsEmptyText}</p>
                    </div>
                }
            />
        </SpaceBetween>
    );
}
